<template>
    <v-container>
        <create-difficulty-index @create="updateList"></create-difficulty-index>

        <v-simple-table>
            <thead>
                <tr>
                    <th>
                        Nama
                    </th>
                    <th>
                        Deskripsi
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr
                    v-for="difficulty in difficulties"
                    :key="difficulty.id"
                >
                    <td>{{ difficulty.title }}</td>
                    <td>{{ difficulty.description }}</td>
                </tr>
            </tbody>
        </v-simple-table>
    </v-container>
</template>

<script>
import CreateDifficultyIndex from './CreateDifficultyIndex.vue'

export default {
    components: {
        CreateDifficultyIndex,
    },

    data: () => ({
        difficulties: null
    }),

    methods: {
        async updateList() {
            const response = await this.$apiv2.get('difficulty-index', { loader: 'appbar' })

            this.difficulties = response.data.difficultyIndex
        }
    },

    created() {
        this.updateList()
    }
}
</script>
